module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-14.0c0d820b.png";